import CardCarousel from '../card-carousel.vue'
import CompanyInfo from './company-info.vue'
import MdContent from 'components/md-content-v2'
import Finances from './finances.vue'


const __default__ = {
  props: {
    company: {type: Object, required: true},
    loading: {type: Boolean, default: false},
    idx: {type: Number, required: true},
    readonly: {type: Boolean, default: false},
  },
  computed: {
    info() {
      return this.company.info
    },
    sections() {
      return this.company.sections
    }
  },
  methods: {
    save(ext){
      this.$dispatch('document-save', {
        card_idx: this.idx,
        ext
      })
    },
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'company',
  emits: ['follow-company'],
  setup(__props, { expose: __expose }) {
  __expose();



const __returned__ = { CardCarousel, CompanyInfo, get MdContent() { return MdContent }, Finances }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})